export async function submitContactForm(payload) {
  const response = await fetch("/api/contact", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorMessage = "Failed to send message.";

    try {
      const data = await response.json();
      errorMessage = data.error || errorMessage;
    } catch (error) {
      // Fall back to the default message when the response is not JSON.
    }

    throw new Error(errorMessage);
  }

  return response.json();
}
